<template>
  <div class="button-box">
    <span class="name"
          :style="{'color':type?'selectedColor':'',  'padding-right': showIcon?'20px':'' }">{{ name }}</span>
    <div v-if="showIcon" class="icon-box">
      <a-icon type="caret-up" class="top-icon" :style="{color:type==='up'?selectedColor:'#555555',fontSize: '14px'}"/>
      <a-icon type="caret-down" class="bottom-icon"
              :style="{color:type==='down'?selectedColor:'#555555',fontSize: '14px'}"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SortButton',
  props: {
    name: {
      type: String,
      default: ''
    },
    selectedColor: {
      type: String,
      default: '#FAAD14'
    },
    //up or down
    type: {
      type: String,
      default: ''
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}
}
</script>
<style scoped lang="less">
.button-box {
  text-align: center;
  height: 26px;
  position: relative;

  .name {
    line-height: 26px;
  }

  .icon-box {
    height: 26px;
    width: 14px;
    display: inline-block;
    position: absolute;
    right: 0;
    top: 0;

    .bottom-icon {
      height: 14px;
      width: 14px;
      position: absolute;
      top: 12px;
    }

    .top-icon {
      height: 14px;
      width: 14px;
      position: absolute;
      bottom: 8px;
    }
  }
}
</style>